import { CardContent } from "@material-ui/core";
import React, { Fragment } from "react";
import { Datagrid, FunctionField, ReferenceField, TextField } from "react-admin";
import FilterToolbar from "../../../../Components/FiltersToolbar/FilterToolbar";
import { DefaultPerPageSize } from "../../../../Constants/Constant";
import { AarConditions } from "../../../../Enums/AarConditions";
import { AarStorageLocations } from "../../../../Enums/AarStorageLocations";
import { FilterInputType, FilterTypes } from "../../../../Enums/FilterTypes";
import { SourceAarStorage, Titles } from "./Constant/Source";
import Actions from "./Actions";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import { AarStorageExcelHeader, AarStorageExcelName } from "./Constant/Excel";
import { SourceVwUser } from "../../../../Constants/Source";
import { useAuth } from "@airborne/react-admin";
import PoolList from "../../../../Components/PoolListComponent/PoolListComponent";

export const AarStorageList = props => {
  const { user } = useAuth();
  const ExportToExcel = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, "requestId", "pbhrequestorders/getpbhrequestlist").then(refNumbers => {
      fetchRelatedRecords(records, "createdBy", SourceVwUser).then(createdBy => {
        const data = records.map(record => ({
          ...record,
          requestId: refNumbers[record.requestId]?.refNo,
          createdBy: /^\d+$/.test(record?.createdBy)
            ? `${createdBy[record.createdBy]?.registerId} - ${createdBy[record.createdBy]?.name}`
            : record?.createdBy,
        }));
        ExcelExport(
          AarStorageExcelHeader,
          data.map(value => [
            value.pn,
            value.sn,
            value.pnDesc,
            AarStorageLocations?.find?.(x => x.Value == value.storage)?.Description ?? "",
            AarConditions?.find?.(x => x.Value == value.condition)?.Description ?? "",
            value.note,
            value.requestId,
            value.createdBy,
            value.createdDate,
          ]),
          AarStorageExcelName
        );
      });
    });
  };
  return (
    <Fragment>
      <CardContent>
        <PoolList
          {...props}
          bulkActionButtons={false}
          title={Titles.list}
          exporter={ExportToExcel}
          perPage={DefaultPerPageSize}
          resource={SourceAarStorage}
          hasCreate={!user?.isCustomer}
          filters={
            <FilterToolbar
              dataSource={[
                {
                  style: { minWidth: "250px" },
                  inputType: FilterInputType.Select,
                  filterTypeChangeDisable: true,
                  filterType: FilterTypes.Equals,
                  source: "storage",
                  label: "Storage",
                  choices: AarStorageLocations,
                  optionValue: "Value",
                  optionText: "Description",
                },
                {
                  style: { minWidth: "250px" },
                  inputType: FilterInputType.Select,
                  filterTypeChangeDisable: true,
                  filterType: FilterTypes.Equals,
                  source: "condition",
                  label: "Condition",
                  choices: AarConditions,
                  optionValue: "Value",
                  optionText: "Description",
                },
                {
                  style: { minWidth: "250px" },
                  source: "pn",
                  inputType: FilterInputType.Text,
                  label: "Pn",
                  filterType: FilterTypes.Contains,
                },
              ]}
            />
          }
        >
          <Datagrid>
            {!user?.isCustomer && <Actions label="Actions" props={props} />}
            <TextField source="pn" label={"PN"} />
            <TextField source="sn" label={"SN"} />
            <TextField source="pnDesc" label={"PN DESCRIPTION"} />
            <FunctionField
              label="STORAGE"
              render={(record: any) => AarStorageLocations?.find?.(x => x.Value == record.storage)?.Description ?? ""}
            />
            <FunctionField
              label="CONDITION"
              render={(record: any) => AarConditions?.find?.(x => x.Value == record.condition)?.Description ?? ""}
            />
            <ReferenceField label="Ref Number" source="requestId" reference={"pbhrequestorders"}>
              <TextField source="refNo" />
            </ReferenceField>
            <TextField source="note" label={"NOTE"} />
          </Datagrid>
        </PoolList>
      </CardContent>
    </Fragment>
  );
};

export default AarStorageList;
